import { useState, useEffect,useRef } from "react";
import React from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import 'assets/css/themecustom-style.css';
import { useHistory,useParams } from "react-router-dom";
const axios = require("axios");
import {usermanageService} from '../../services/usermanageService';
import {taskmanageService} from '../../services/taskmanageService';
import { ToastContainer, toast } from 'react-toastify';

const Leave  = (props) => {
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [data, setdata] = useState([]);
  const [filterFields,setfilterFields] = useState([]);
  const [filtertype,setfiltertype] = useState('open');
  const [file, setFile] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
const [total_page,setTotalData] = useState(0);
const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const handlePageClick = (e, index) => {
    e.preventDefault();
    get_list(index);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_list(prev,rowsPerPage);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_list(next,rowsPerPage);
  };

  const get_list = async (pageNumber = 1,rowsPerPage='') => {
    usermanageService.getLeaves(pageNumber,rowsPerPage,month_year).then((response) => {
        setdata(response.data.data);
        setCurrentPage(response.data.current_page);
         setLastPageData(response.data.last_page);
         setTotalData(response.data.total);
    });
  };
const [month_year,setSelMonthYear]=useState('');
const setMonthYear = (e,index) => {
    setSelMonthYear(e.target.value)
}
  useEffect(() => {
    get_list();
  }, []);

  const download_sample  = ()=>{
    usermanageService.common_download_sample('leave_sample.xlsx').then((response) => {
    });
  }
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFile(file)
  };
  const importfile = ()=>{
    usermanageService.leave_import( file,month_year).then((response) => {
      if (response.status === 200) {
        get_list(1,)
          toast.success(response.data.message);
          response.data.errors.forEach((messages) => {
              toast.error(messages);
            });
          
      } else {
          
          if (response.status == 422) {
            Object.values(response.data.errors).forEach((messages) => {
                messages.forEach((msg) => {
                  toast.error(msg);
                });
              });
              
              
          } else {
              toast.error('An error occurred while importing data.'); // Fallback error message
          }
      }
  }).catch((error) => {
      toast.error('Error importing data: ' + error.message);
  });
  
  }
  return (
    <>
    <Header />
    <Container className="mt--7" fluid>
    <Row>
    <div className="col-xl-4 col-md-4 col-xs-4">
                    <h3 className="clientformtag"> Select month</h3>
                    <input type="month"
                                      className="form-control"
                                      name="todate"
                                      onChange={(e) =>
                                        setMonthYear(e)
                                        }
                                    
                                        
                                      />
                                       
                      
                                  </div>
    <div className="col-12 mt-4">
             
              <input
                type="file"
                accept=".xls,.xlsx"
                onChange={handleFileUpload}
                style={{width:'200px'}}
              />
             
            <Button color="primary" type="button" style={{background:"rgb(2, 199, 121)",border:"rgb(2, 199, 121)"}} onClick={importfile}>
            Import
            </Button> 
            <a style={{color:'blue',cursor:'pointer'}} onClick={download_sample} download>Download Sample File</a> 
              </div>
          
          
          </Row>
          <Row className="mt-5">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center row">
                <div className="col-xl-8 col-md-2 col-xs-12">
                  <h3 className="mb-0" style={{ fontSize: "20px" }}>
                   Leaves
                  </h3>
                  </div>
                
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Count</th>
                  <th scope="col">Mont</th>
                 
                  
                </thead>
                <tbody>
                  {data && data.length && data != null ? (
                    data.map((item, i) =>
                      item != undefined ? (
                        <>
                          <tr
                            className={
                              i % 2 == 0
                                ? "blue-row"
                                : i % 3 == 0
                                ? "purple-row"
                                : "orange-row"
                            }
                          >
                            <td>{item.user_name}</td>
                            <td>{item.email}</td>
                            <td>{item.count}</td>
                            <td>{item.month_year}</td>
                            
                            
                           
                          </tr>
                        </>
                      ) : (
                        <></>
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
     </Container>
    </>
  );
};


export default Leave;
